import { PostMethod, GetMethod } from '../../../serviceHelper';

const getMethods = (service: 'dm', controller: 'DocumentManagement/Explorer') => ({
	GetObjectsContext: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetObjectsContext'
	}),
	GetExplorerData: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetExplorerData'
	}),
	GetGridContext: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetGridContext'
	}),
	AddObjectsToFavorites: new PostMethod<any, any>({
		service,
		controller,
		method: 'AddObjectsToFavorites'
	}),
	DeleteObjectFromFavorites: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteObjectFromFavorites'
	}),
	GetRecentObjects: new GetMethod<any, any>({
		service,
		controller,
		method: 'GetRecentObjects'
	}),
	GetFavorites: new GetMethod<any, any>({
		service,
		controller,
		method: 'GetFavorites'
	}),
	GetLegacyUrl: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetLegacyUrl'
	}),
	DeleteRelationFromFile: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteRelationFromFile'
	}),
	GetRelationFilesOfTheFile: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetRelationFilesOfTheFile'
	}),
	AddRelationToFile: new PostMethod<any, any>({
		service,
		controller,
		method: 'AddRelationToFile'
	}),
	Search: new PostMethod<any, any>({
		service,
		controller,
		method: 'Search'
	}),
	GetPaths: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetPaths'
	}),
	CheckDocumentExistAndAuthorize: new PostMethod<any, any>({
		service,
		controller,
		method: 'CheckDocumentExistAndAuthorize'
	}),
	DeleteObjectFromRecents: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteObjectFromRecents'
	}),
	GetParameters: new GetMethod<any, any>({
		service,
		controller,
		method: 'GetParameters'
	}),
	GetDMObjectsFromPath: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetDMObjectsFromPath'
	}),
	Share: new PostMethod<any, any>({
		service,
		controller,
		method: 'Share'
	}),
	ExcelSearch: new PostMethod<any, any>({
		service,
		controller,
		method: 'ExcelSearch'
	}),
	Profile: new PostMethod<any, any>({
		service,
		controller,
		method: 'Profile'
	}),
	DeleteAll: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteAll'
	}),
	CalculateCounts: new PostMethod<any, any>({
		service,
		controller,
		method: 'CalculateCounts'
	}),
	CalculateSizes: new PostMethod<any, any>({
		service,
		controller,
		method: 'CalculateSizes'
	})
});

export { getMethods };
